<ng-container *ngIf="orientation==='vertical'">
  <om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
  <nz-switch [formControl]="control"></nz-switch>
  <om-error [control]="control"></om-error>
</ng-container>
<ng-container *ngIf="orientation==='horizontal'">
  <div nz-row [nzGutter]="16" nzAlign="middle">
    <div nz-col>
      <nz-switch [formControl]="control"></nz-switch>
    </div>
    <div nz-col nzFlex="auto">
      <om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
    </div>
  </div>
  <div nz-row [nzGutter]="16">
    <om-error [control]="control"></om-error>
  </div>
</ng-container>
